import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography, LinearProgress } from '@mui/material';
import { loadStatus } from '../../../helpers/socket';

const DisplayResponseTelecs = React.memo(({ result }) => {
  const panels = useSelector(state => state.panels.panels);

  return (
    <>
      {result?.result?.msg &&
        Array.isArray(result.result.msg) &&
        result.topic?.includes('telecs') && (
          <>
            {result.result.msg.map(e => {
              const device = panels.find(item => item.ip === e.ip);
              if (!device) return null;

              let progress = null;
              if (e.num_file !== undefined && e.total_file !== undefined) {
                progress = Math.floor(((e.num_file + 1) / e.total_file) * 100);
              }

              return (
                <Grid container key={device.id}>
                  <Grid item xs={4}>
                    <Typography>
                      {device.name}, {device.ip}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {progress !== null && (
                      <>
                        <LinearProgress variant="determinate" value={progress} />
                        <Typography variant="caption">{progress}%</Typography>
                      </>
                    )}
                    <Typography variant="caption">{loadStatus(e?.estado)}</Typography>
                    <br />
                    <Typography variant="caption">{e.result}</Typography>
                  </Grid>
                </Grid>
              );
            })}
          </>
        )}
    </>
  );
});

export default DisplayResponseTelecs;
